import { gql, useMutation } from '@apollo/client';
import { GET_PAYROLL_ACCOUNTING_SETTINGS } from './get-payroll-accounting-settings.hook';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';
import { GET_PAYROLL_ACCOUNTING_ACTIVE_SETTINGS } from './get-payroll-accounting-active-settings.hook';

export const UPDATE_PAYROLL_ACCOUNTING_SETTINGS = gql`
  mutation updatePayrollAccountingSetting($payload: UpdatePayrollAccountingSettingInput!) {
    updatePayrollAccountingSetting(payload: $payload) {
      _id
    }
  }
`;

export const useUpdatePayrollAccountingSetting = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('payrollAccounting');
  const [updatePayrollAccountingSetting] = useMutation(UPDATE_PAYROLL_ACCOUNTING_SETTINGS, {
    onCompleted: data => {
      if (data?.updatePayrollAccountingSetting?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('notifications.updated'),
        });
      }
      if (onSuccess) {
        onSuccess();
      }
    },
    refetchQueries: [GET_PAYROLL_ACCOUNTING_SETTINGS, GET_PAYROLL_ACCOUNTING_ACTIVE_SETTINGS],
  });

  return updatePayrollAccountingSetting;
};
